import React, { useEffect, useMemo, useState } from 'react';

import { useTheme } from '@mui/material/styles';

import { getIsNativePlatform } from 'utils/platform';

import {
  activeStyle,
  carouselContainerStyle,
  carouselSlideStyle,
  getOverlayStyle,
  imageCarouselStyle,
  nativeCarouselContainerStyle,
} from './BackgroundCarousel.styles';
import { BackgroundCarouselTestIds } from './BackgroundCarousel.testIds';
import { CAROUSEL_INTERVAL_MS, realEstateImages } from './images.constants';

const getImageStyles = ({ imageUrl }) => ({ backgroundImage: `url(${imageUrl})` });

const BackgroundCarousel = () => {
  const theme = useTheme();
  const overlayStyle = useMemo(() => getOverlayStyle(theme), [theme]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // On native the login route is hosted inside the safe-area-padded content area, so an absolute
  // height:100% carousel only fills the inset box and the padding shows the white surface (STP-179).
  // Break out to the visual viewport so the background renders edge-to-edge under the Island/home bar.
  const containerStyle = getIsNativePlatform()
    ? nativeCarouselContainerStyle
    : carouselContainerStyle;

  const slideStyles = useMemo(
    () =>
      realEstateImages.map((imageUrl, index) => ({
        ...carouselSlideStyle,
        ...(index === currentImageIndex ? activeStyle : undefined),
        ...getImageStyles({ imageUrl }),
      })),
    [currentImageIndex],
  );

  // Change image every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % realEstateImages.length);
    }, CAROUSEL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return (
    <div data-testid={BackgroundCarouselTestIds.CAROUSEL} style={containerStyle}>
      <div style={imageCarouselStyle}>
        {realEstateImages.map((imageUrl, index) => (
          <div key={index} style={slideStyles[index]}>
            <div style={overlayStyle} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BackgroundCarousel;
